module.exports = __webpack_public_path__ + "img/cg4.6d12a4c5.png";